import React, { useCallback } from 'react';
import { ActiveTag, Content, Data, Description, Image, LeftSection, SectionWrapper, TagDiv, Title } from './styles';
import AppLayout from '../../../../component/appLayout';
import ResponsiveHeader from '../../../../component/responsiveHeader';
import { useMobileDevice } from '../../../../global/useMobile';
import BottomSubNavigation from '../../../../component/bottomNavigation/subNavigation';
import Button from '../../../../component/button';
import { useHistory } from 'react-router-dom';
import { rootStore } from '../../../../mobx/rootStore';
import { activateAgent, deactivateAgent } from '../../../../services/workspaceService';
import { observer } from 'mobx-react-lite';
import { BUTTON_TYPE } from '../../../../global/constants';
import { Group, Header, PersonalText, Container } from '../../styles';
import {ROUTES} from "../../../../routes/urls"
const AIAgents = () => {
  //Mobx store
  const { workspaceStore } = rootStore;
  const { currentWorkspace } = workspaceStore;

  // other variables
  const isMobile = useMobileDevice();
  const history = useHistory();

  const onClickCard = useCallback(
    (agentId: string) => {
      history.push(ROUTES.AI_AGENTS_SETTING_DETAILS.replace(':id', agentId));
    },
    [history]
  );

  const handleActivateAgent = useCallback(
    async (e: React.SyntheticEvent, agentId: string, isActive: boolean) => {
      e.stopPropagation();
      if (isActive) {
        await deactivateAgent(agentId);
        currentWorkspace?.disableAgent(agentId);
      } else {
        await activateAgent(agentId);
        currentWorkspace?.enableAgent(agentId);
      }
    },
    [currentWorkspace]
  );

  return (
    <>
      <AppLayout>
        <Container className='desktop-content'>
          <Group>
            {isMobile ? (
              <ResponsiveHeader title='AI Agents' />
            ) : (
              <Header>
                <PersonalText>AI Agents</PersonalText>
              </Header>
            )}
            <Content>
              {currentWorkspace?.aiAgents?.map((agent) => {
                return (
                  <Data role='button' onClick={() => onClickCard(agent.id)}>
                    <LeftSection>
                      <Image src={agent.profile_photo} alt='ai-agent' width={32} height={32} />
                      <SectionWrapper>
                        <Title>{agent.name}</Title>
                        <Description>{agent.description}</Description>
                      </SectionWrapper>
                    </LeftSection>
                    {!agent.isActive ? (
                      <Button
                        title='Activate'
                        variant={BUTTON_TYPE.SECONDARY}
                        buttonType='button'
                        size='small'
                        onClick={(e: React.SyntheticEvent) => handleActivateAgent(e, agent.id, agent.isActive)}
                      />
                    ) : (
                      <TagDiv>
                        <ActiveTag
                          role='button'
                          onClick={(e) => handleActivateAgent(e, agent.id, agent.isActive)}
                          className='active-tag'>
                          Active
                        </ActiveTag>
                        <Button
                          title='Deactivate'
                          buttonType='button'
                          size='small'
                          variant={BUTTON_TYPE.SECONDARY}
                          onClick={(e: React.SyntheticEvent) => handleActivateAgent(e, agent.id, agent.isActive)}
                          className='deactivate-button'
                        />
                      </TagDiv>
                    )}
                  </Data>
                );
              })}
            </Content>
          </Group>
        </Container>
      </AppLayout>
      <BottomSubNavigation />
    </>
  );
};

export default observer(AIAgents);
